<template>
  <div class="detail-container">
    <slot name="page-header"></slot>
    <CardContainer padding="0">
      <div class="detail-top">
        <slot name="top"></slot>
      </div>
      <div class="detail-bottom">
        <slot></slot>
      </div>
    </CardContainer>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.detail-top {
  padding: 24px;
  box-shadow: 0px -2px 20px 0px rgba(34, 42, 57, 0.1);
}
.detail-bottom {
  padding: 24px;
}
</style>
